import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuditLogData, isEventAuditLog, isOrderAuditLog, isPaymentLinkAuditLog, isVoucherAuditLog } from '../types';

type AuditLogEntityLinkProps = {
  log: AuditLogData;
};

export const AuditLogEntityLink: React.FC<AuditLogEntityLinkProps> = ({ log }) => {
  const { t } = useTranslation();

  const getEntityText = (): string => {
    if (isOrderAuditLog(log)) {
      return t('auditlog.entity_info.order', { orderNumber: log.order_number });
    }

    if (isEventAuditLog(log)) {
      return t('auditlog.entity_info.event');
    }

    if (isVoucherAuditLog(log)) {
      return t('auditlog.entity_info.voucher', { orderNumber: log.order_number });
    }

    if (isPaymentLinkAuditLog(log)) {
      return t('auditlog.entity_info.payment_link', { paymentLinkNumber: log.payment_link_number });
    }

    return t('auditlog.entity_info.unknown');
  };

  const getEntityLink = (): string | null => {
    if (isOrderAuditLog(log)) {
      return `/dashboard/calendar?entityid=${log.order_id}`;
    }

    if (isEventAuditLog(log)) {
      return `/dashboard/calendar?entityid=${log.event_id}`;
    }

    if (isVoucherAuditLog(log)) {
      return `/dashboard/vouchers`;
    }

    if (isPaymentLinkAuditLog(log)) {
      return `/dashboard/payment-links`;
    }

    return null;
  };

  const entityText = getEntityText();
  const entityLink = getEntityLink();

  if (entityLink) {
    return (
      <Link
        to={entityLink}
        style={{
          color: '#1976d2',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.textDecoration = 'underline';
          e.currentTarget.style.color = '#115293';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.textDecoration = 'underline';
          e.currentTarget.style.color = '#1976d2';
        }}>
        {entityText}
      </Link>
    );
  }

  return <span>{entityText}</span>;
};
